import React from 'react';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import '../css/PrivacyPage.css';
import '../css/WarrantyPage.css';

const ReturnPolicyPage = () => {
    return (
        <Layout>
            <SEO
                title="Гарантія та повернення — Union Auto"
                description="Умови гарантії та повернення б/у автозапчастин в інтернет-магазині Union Auto. Гарантія 14 днів. Повернення за законом України."
                canonical="/return-policy"
            />
            <div className="privacy-page warranty-page">

                <header className="privacy-header">
                    <h1 className="privacy-title">Гарантія та повернення</h1>
                    <p className="privacy-date">
                        Усі товари — вживані автозапчастини (б/в), зняті з автомобілів у справному стані
                    </p>
                </header>

                {/* Гарантія */}
                <section className="privacy-section">
                    <h2>Гарантія на товари</h2>
                    <p>
                        Усі товари, представлені в нашому інтернет-магазині, є вживаними автозапчастинами
                        (б/в), знятими з автомобілів у справному, робочому стані.
                    </p>

                    <div className="warranty-highlight">
                        <span className="warranty-highlight__icon">🛡</span>
                        <div>
                            <strong>14 календарних днів</strong> — гарантія від магазину з моменту
                            отримання товару Покупцем, якщо інший строк не вказаний в описі товару.
                        </div>
                    </div>

                    <div className="warranty-grid">
                        <div className="warranty-box warranty-box--ok">
                            <div className="warranty-box__title">
                                <span className="warranty-box__icon">✓</span> Гарантія поширюється на
                            </div>
                            <ul className="warranty-box__list">
                                <li>Приховану несправність деталі, яку неможливо було виявити при перевірці перед продажем</li>
                                <li>Несправності, не виявлені при знятті та перевірці запчастини</li>
                                <li>Невідповідність товару заявленим характеристикам або номеру деталі</li>
                            </ul>
                        </div>

                        <div className="warranty-box warranty-box--no">
                            <div className="warranty-box__title">
                                <span className="warranty-box__icon">✕</span> Гарантія не поширюється на
                            </div>
                            <ul className="warranty-box__list">
                                <li>Механічні пошкодження, отримані після отримання товару</li>
                                <li>Пошкодження внаслідок неправильного монтажу або експлуатації</li>
                                <li>Сліди самостійного ремонту чи втручання третіх осіб</li>
                            </ul>
                        </div>
                    </div>
                </section>

                {/* Особливості б/в */}
                <section className="privacy-section">
                    <h2>Особливості вживаних запчастин</h2>
                    <p>
                        Усі запчастини є б/в деталями, зібраними з автомобілів у справному стані.
                        Вживані деталі можуть мати сліди встановлення, природного зношування та косметичних
                        пошкоджень, що не впливають на їх працездатність.
                    </p>
                    <p>
                        Інформація про стан конкретної деталі, її особливості та наявні дефекти зовнішнього
                        вигляду вказується в описі товару на сайті або надається менеджером при замовленні.
                    </p>
                    <div className="warranty-note">
                        Незначні косметичні дефекти вживаної деталі, про які Покупець був повідомлений до
                        покупки, не є підставою для повернення чи обміну.
                    </div>
                </section>

                {/* Перевірка при отриманні */}
                <section className="privacy-section">
                    <h2>Перевірка товару при отриманні</h2>
                    <p>При отриманні замовлення Покупець повинен перевірити:</p>
                    <ul>
                        <li>відповідність товару опису та артикулу з замовлення;</li>
                        <li>зовнішній вигляд та стан деталі;</li>
                        <li>комплектність (за наявності);</li>
                        <li>цілісність упакування.</li>
                    </ul>
                    <p>
                        Покупець має право оглянути товар у відділенні перевізника до підписання документів
                        про отримання.
                    </p>
                    <p>
                        У разі виявлення невідповідності замовлення або пошкоджень, отриманих при доставці,
                        рекомендується відмовитися від отримання відправки та негайно повідомити менеджера
                        магазину.
                    </p>
                </section>

                {/* Повернення */}
                <section className="privacy-section">
                    <h2>Повернення та обмін товару</h2>
                    <p>
                        Відповідно до Закону України «Про захист прав споживачів», Покупець має право
                        повернути чи обміняти товар належної якості протягом{' '}
                        <strong>14 календарних днів</strong> з моменту отримання.
                    </p>

                    <h3 className="warranty-h3">Умови повернення товару належної якості</h3>
                    <ul>
                        <li>Збережено товарний вигляд (у тому стані, в якому він був отриманий)</li>
                        <li>Збережено повну комплектацію</li>
                        <li>Збережено упаковку (за наявності)</li>
                        <li>Наявний документ, що підтверджує придбання товару</li>
                    </ul>

                    <h3 className="warranty-h3">Порядок оформлення повернення або обміну</h3>
                    <ol className="warranty-steps">
                        <li>
                            <span className="warranty-steps__num">1</span>
                            <span>Повідомте нас про намір повернути або обміняти товар зручним способом.</span>
                        </li>
                        <li>
                            <span className="warranty-steps__num">2</span>
                            <div>
                                Надайте наступну інформацію:
                                <ul style={{ marginTop: 8 }}>
                                    <li>прізвище та ім'я отримувача;</li>
                                    <li>номер замовлення;</li>
                                    <li>товар, який бажаєте обміняти або повернути;</li>
                                    <li>причину обміну чи повернення;</li>
                                    <li>фото або відео товару та упаковки.</li>
                                </ul>
                            </div>
                        </li>
                        <li>
                            <span className="warranty-steps__num">3</span>
                            <span>Повідомте номер декларації відправленої посилки та номер банківської картки для повернення коштів.</span>
                        </li>
                        <li>
                            <span className="warranty-steps__num">4</span>
                            <span>Після отримання та перевірки товару протягом <strong>3 робочих днів</strong> ми повертаємо кошти або надсилаємо інший товар.</span>
                        </li>
                    </ol>

                    <div className="warranty-note warranty-note--warn">
                        Не надсилайте товар без попереднього погодження з менеджером.
                    </div>

                    <p style={{ marginTop: 16 }}>
                        У разі виявлення прихованого браку або пошкодження — повідомте нас одразу після
                        отримання та надішліть фото або відео.
                    </p>

                    <h3 className="warranty-h3">Вартість зворотньої доставки</h3>
                    <div className="warranty-delivery-grid">
                        <div className="warranty-delivery-item">
                            <span className="warranty-delivery-item__label">Товар належної якості</span>
                            <span className="warranty-delivery-item__sub">повернення за бажанням покупця</span>
                            <span className="warranty-delivery-item__who warranty-delivery-item__who--buyer">
                                За рахунок Покупця
                            </span>
                        </div>
                        <div className="warranty-delivery-item">
                            <span className="warranty-delivery-item__label">Товар неналежної якості</span>
                            <span className="warranty-delivery-item__sub">брак, прихована несправність</span>
                            <span className="warranty-delivery-item__who warranty-delivery-item__who--seller">
                                За рахунок Продавця
                            </span>
                        </div>
                    </div>

                    <h3 className="warranty-h3">Повернення коштів</h3>
                    <ul>
                        <li>Повернення коштів здійснюється на банківську картку Покупця.</li>
                        <li>Кошти повертаються протягом <strong>3 робочих днів</strong> з моменту отримання товару Продавцем.</li>
                    </ul>
                </section>

            </div>
        </Layout>
    );
};

export default ReturnPolicyPage;
